/**
 * Project : workspace
 * File    : ConversationCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.chat.conversation.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.BusinessCenter
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.communication.core.conversation.viewModel.ConversationViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.ui.component.image.ImageView
import component.visual.DottedLine
import theme.ThemeColor
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Composable
/**
 * Executes the conversation card operation.
 *
 * @receiver TODO
 * @param data The data.
 * @param viewModel The view model.
 * @param authViewModel The auth view model.
 * @param onClick The on click.
 * @return Unit – no return value.
 */
fun ConversationCard(data: Conversation, viewModel: ConversationViewModel, authViewModel: AuthViewModel, onClick: (Conversation) -> Unit = {}) {
    var user by remember { mutableStateOf(FriendlyUser()) }

    LaunchedEffect(key1 = data._id) {
        data.Participants?.forEach { participantId ->
            if(participantId != AuthHandler.shared().UserID){
                authViewModel.getUserDetails(participantId){userDetails->
                    user = userDetails
                }
            }
        }
    }
    Surface(
        shape = RoundedCornerShape(16.dp),
        color = ThemeColor.shared().cardBackground,
        modifier = Modifier
            .height(124.dp)
            .padding(start = 8.dp, top = 8.dp, end = 8.dp),
        shadowElevation = 4.dp,
        onClick = { onClick(data) }
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .padding(start = 8.dp, end = 8.dp, top = 8.dp),
            ) {
            Row(
                modifier = Modifier
                    .height(68.dp).fillMaxWidth()
                    .background(
                        color = ThemeColor.shared().cardLightGrayContentBackground,
                        shape = RoundedCornerShape(8.dp)
                    )
                    .padding(start = 8.dp, top = 8.dp, end = 8.dp)
            ) {
                Box(
                    modifier = Modifier
                        .height(57.dp).width(57.dp)
                        .background(
                            color = ThemeColor.shared().cardLightGrayContentBackground,
                            shape = RoundedCornerShape(8.dp)
                        )
                        .padding(start = 8.dp, top = 8.dp, end = 8.dp)
                ) {
                    ImageView(user._id,BusinessHandler.shared().selectedBusinessId)
                }
                Column(Modifier.weight(0.5f).fillMaxHeight().padding(start = 8.dp)) {
                    Row(modifier = Modifier.height(28.dp)) {
                        Text(
                            text = user.Name,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier
                                .height(85.dp).fillMaxWidth(),
                            textAlign = TextAlign.Start,
                        )
                    }
                    Row(modifier = Modifier.height(23.dp).fillMaxWidth()) {
                        Icon(
                            Icons.Default.Email,
                            contentDescription = "Email",
                            modifier = Modifier.width(23.dp).height(23.dp).padding(top = 3.dp),
                            tint = ThemeColor.shared().lightGray
                        )
                        Text(
                            text = user.EmailID,
                            maxLines = 2,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier
                                .height(20.dp).fillMaxWidth(),
                            textAlign = TextAlign.Start,
                            color = ThemeColor.shared().lightGray
                        )
                    }
                }
            }
            DottedLine()
            Row(modifier = Modifier.height(24.dp)) {
                Row(
                    modifier = Modifier.height(23.dp).weight(0.5f).fillMaxWidth().fillMaxSize(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        Icons.Default.Phone,
                        contentDescription = "Phone",
                        modifier = Modifier.width(23.dp).height(23.dp).padding(top = 3.dp),
                        tint = ThemeColor.shared().lightGray
                    )
                    Text(
                        text = user.DialCode + user.MobileNumber,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier
                            .wrapContentHeight().fillMaxWidth(),
                        textAlign = TextAlign.Start,
                        fontSize = 12.sp,
                        color = ThemeColor.shared().lightGray
                    )
                    Icon(
                        Icons.Default.BusinessCenter,
                        contentDescription = "JobType",
                        modifier = Modifier.width(23.dp).height(23.dp).padding(top = 3.dp),
                        tint = ThemeColor.shared().lightGray
                    )
                }
            }
        }
    }
}